(function() {
     function initCustomGallery() {
       const gallery = document.getElementById('customGallery');
       if (!gallery) return;
   
       const items = gallery.querySelectorAll('.custom-gallery__item');
       
       function toggleActive(item) {
         const wasActive = item.classList.contains('active');
         items.forEach(el => {
           el.classList.remove('active');
           const media = el.querySelector('video, img');
           if (media && media.tagName === 'VIDEO') {
             media.pause();
             media.muted = true;
           }
         });
         
         if (!wasActive) {
           item.classList.add('active');
           const media = item.querySelector('video, img');
           if (media && media.tagName === 'VIDEO') {
             media.muted = false;
             media.play();
           }
         }
       }
       
       items.forEach(item => {
         item.addEventListener('click', () => toggleActive(item));
       });
     }

     // Run on page load
     document.addEventListener('DOMContentLoaded', initCustomGallery);

     // Run on Shopify theme editor events
     if (Shopify.designMode) {
       document.addEventListener('shopify:section:load', initCustomGallery);
       document.addEventListener('shopify:section:select', initCustomGallery);
     }
   })();